const CONCERNS = [
  'Acne',
  'Blemishes',
  'Dryness',
  'Dark spots',
  'PH balance',
  'Loss of firmness',
  'Pores',
  'Dullness',
  'Uneven texture',
  'Uneven complexion',
  'Sensitivity',
  'Lines & wrinkles',
  'Sun exposure',
  'Oiliness',
  'Redness',
];

export default CONCERNS;
